export const types = {
    INV_SEARCH_ACTION: "inv/invSearchAction"
};

let initialState = {
    search: {
        isLoading: false,
        searchText: "",
        data: []
    }
};

export const invoice = (state = initialState, action) => {
    switch (action.type) {
        case types.INV_SEARCH_ACTION:
            return { 
                ...state, 
                search: {
                    ...state.search,
                    ...action.payload
                }  
            };
        default:
            return state;
    }
};